export default "__VITE_ASSET__B5i6P4Ug__"